export const modules = [
        {
            parentModule: "CRM",
            subModules: [
                { name: "Leads" },
                { name: "Client" },
                { name: "Company" },
                { name: "Deals" },
                { name: "Walkthrough" },
                { name: "Quotes" },
                { name: "Task Master" },
            ]

        },
        {
            parentModule: "Sales",
            subModules: [
                { name: "Orders" },
            ]
        },
        {
            parentModule: "Inventory",
            subModules: [
                { name: "Shades" },
                { name: "Items" },
                { name: "Category" },
                { name: "Product Review" },
            ]
        }, 
        {
            parentModule: "Production",
            subModules: [
                { name: "Prepare Job Card" },
                { name: "BOM" },
                { name: "Job Card" },
                { name: "Label" },
                { name: "Material Request" },
                { name: "Production Order" },
                { name: "Production Planning" },
            ]

        },
        {
            parentModule: "Tag Master",
            subModules: [
                { name: "Tag Master" },
            ]
        },
        {
            parentModule: "Bill",
            subModules: [
                { name: "Bill" },
            ]
        }
    ]